import axios from "axios";
import { API_URL } from "../variables";
export const UPLOAD_FILE_REQUEST = "UPLOAD_FILE_REQUEST";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE = "UPLOAD_FILE_FAILURE";

export const uploadFile = (file) => async (dispatch, getState) => {
  dispatch({ type: UPLOAD_FILE_REQUEST });
  const { token } = getState().auth;
  try {
    const response = await axios.post(`${API_URL}/api/files/upload`, file, {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    dispatch({ type: UPLOAD_FILE_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: UPLOAD_FILE_FAILURE, payload: error.message });
  }
};
